import { render, staticRenderFns } from "./protocolText_hk.vue?vue&type=template&id=5eb26974&scoped=true&"
import script from "./protocolText_hk.vue?vue&type=script&lang=js&"
export * from "./protocolText_hk.vue?vue&type=script&lang=js&"
import style0 from "./protocolText_hk.vue?vue&type=style&index=0&id=5eb26974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb26974",
  null
  
)

export default component.exports